import {
  getVideoData,
  saveVideo,
  getSegment,
  getDetail,
  updateDetail,
  updateStatus
} from '@/axios/api/videoManagement'
import { Message } from 'element-ui'

const UPDATE_VIDEO_LIST = 'UPDATE_VIDEO_LIST'
const UPDATE_TOTAL = 'UPDATE_TOTAL'
const UPDATE_PAGER = 'UPDATE_PAGER'
const UPDATE_TBL_LOADING = 'UPDATE_TBL_LOADING'
const UPDATE_DET_LOADING = 'UPDATE_DET_LOADING'
const UPDATE_SEGMENT = 'UPDATE_SEGMENT'
const UPDATE_DETAIL = 'UPDATE_DETAIL'
const UPDATE_STATUS = 'UPDATE_STATUS'

const state = {
  videoList: [],
  tblLoading: false,
  detLoading: false,
  pager: {
    current: 1,
    size: 10,
    total: 0
  },
  segment: [],
  detail: {}
}

const getters = {
  videoList: state => state.videoList,
  tblLoading: state => state.tblLoading,
  detLoading: state => state.detLoading,
  pager: state => state.pager,
  segment: state => state.segment.map(v => {
    return { label: v.title, value: v.id }
  }),
  detail: state => state.detail
}

const mutations = {
  [UPDATE_VIDEO_LIST] (state, videoList) {
    state.videoList = videoList
  },
  [UPDATE_TOTAL] (state, total) {
    state.pager.total = total
  },
  [UPDATE_PAGER] (state, pager) {
    state.pager = {
      ...state.pager,
      ...pager
    }
  },
  [UPDATE_TBL_LOADING] (state, tblLoading) {
    state.tblLoading = tblLoading
  },
  [UPDATE_DET_LOADING] (state, detLoading) {
    state.detLoading = detLoading
  },
  [UPDATE_SEGMENT] (state, segment) {
    state.segment = segment
  },
  [UPDATE_DETAIL] (state, detail) {
    state.detail = detail
  },
  [UPDATE_STATUS] (state, params) {
    state.videoList = state.videoList.map(v => {
      const item = params.id === v.id
        ? { ...v, dataStatus: params.dataStatus }
        : { ...v }
      return item
    })
  }
}

const actions = {
  async getVideoListApi ({ commit }, params) {
    commit(UPDATE_TBL_LOADING, true)
    const { current, size } = { ...params }
    try {
      const { data: res } = await getVideoData({
        current,
        size,
        desc: ['id']
      })
      commit(UPDATE_VIDEO_LIST, res.records)
      commit(UPDATE_TOTAL, res.total)
    } catch (e) {
      Message.error(e)
    }
    commit(UPDATE_TBL_LOADING, false)
  },
  async getSegmentApi ({ commit }) {
    try {
      const { data: res } = await getSegment()
      commit(UPDATE_SEGMENT, res)
    } catch (e) {
      Message.error(e)
    }
  },
  setPagerApi ({ commit }, params) {
    commit(UPDATE_PAGER, params)
  },
  async saveVideoApi ({ commit }, params) {
    commit(UPDATE_DET_LOADING, true)
    try {
      const res = await saveVideo(params)
      if(res.errorCode === 200) Message.success(res.errorMsg)
      commit(UPDATE_DET_LOADING, false)
      return true
    } catch (e) {
      Message.error(e)
      commit(UPDATE_DET_LOADING, false)
      return false
    }
  },
  async getDetailApi ({ commit }, params) {
    commit(UPDATE_DET_LOADING, true)
    try {
      const { data: res } = await getDetail({ id: params.id })
      commit(UPDATE_DETAIL, res)
    } catch (e) {
      Message.error(e)
    }
    commit(UPDATE_DET_LOADING, false)
  },
  async updateDetailApi ({ commit }, params) {
    commit(UPDATE_DET_LOADING, true)
    try {
      const res = await updateDetail(params)
      if(res.errorCode === 200) Message.success(res.errorMsg)
      commit(UPDATE_DET_LOADING, false)
      return true
    } catch (e) {
      Message.error(e)
      commit(UPDATE_DET_LOADING, false)
      return false
    }
  },
  async updateStatusApi ({ commit }, params) {
    commit(UPDATE_TBL_LOADING, true)
    try {
      const data = {
        id: params.id,
        dataStatus: params.dataStatus === 2 ? 3 : 2
      }
      await updateStatus(data)
      Message.success('success')
      commit(UPDATE_STATUS, data)
    } catch (e) {
      Message.error(e)
    }
    commit(UPDATE_TBL_LOADING, false)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/videoManagement.js